import { RouteN } from '../../routes-path';

export const goToTerms = () => {
    return RouteN.terms.route;
};

export const goToPrivacy = () => {
    return RouteN.privacy.route;
};
